import { io } from 'socket.io-client';
import SERVER_CONFIG from './config';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
    this.socketUrl = SERVER_CONFIG.socketUrl;
    this._onConnect = null;
    this._onDisconnect = null;
    this._connectListeners = new Set(); // дополнительные подписчики (конференция)
  }

  async connect(token) {
    if (this.socket?.connected) {
      return;
    }

    console.log('[Socket] Подключение к:', this.socketUrl);

    this.socket = io(this.socketUrl, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Подключено к:', this.socketUrl);
      if (this._onConnect) this._onConnect();
      this._connectListeners.forEach(fn => { try { fn(); } catch (e) { console.error(e); } });
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Отключено:', reason);
      if (this._onDisconnect) this._onDisconnect();
    });

    this.socket.on('error', (error) => {
      console.error('[Socket] Ошибка:', error);
    });

    // Re-attach all listeners
    this.listeners.forEach((callback, event) => {
      this.socket.on(event, callback);
    });
  }

  onConnect(callback) {
    this._onConnect = callback;
  }

  onDisconnect(callback) {
    this._onDisconnect = callback;
  }

  addConnectListener(fn) {
    this._connectListeners.add(fn);
    return () => this._connectListeners.delete(fn);
  }

  // emit с ответом сервера; при обрыве или без ответа — ошибка
  emitWithAck(event, data, timeout = 10000) {
    return new Promise((resolve, reject) => {
      if (!this.socket?.connected) return reject(new Error('Нет связи с сервером'));
      this.socket.timeout(timeout).emit(event, data, (err, resp) => (err ? reject(err) : resolve(resp)));
    });
  }

  isConnected() {
    return this.socket?.connected || false;
  }

  forceReconnect() {
    if (this.socket && !this.socket.connected) {
      console.log('[Socket] Force reconnect');
      this.socket.connect();
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event, callback) {
    this.listeners.set(event, callback);
    if (this.socket) {
      this.socket.off(event);
      this.socket.on(event, callback);
    }
  }

  off(event) {
    this.listeners.delete(event);
    if (this.socket) {
      this.socket.off(event);
    }
  }

  emit(event, data) {
    if (this.socket?.connected) {
      this.socket.emit(event, data);
    }
  }

  sendMessage(channelId, content, messageType = 'text', replyToMessageId = null) {
    this.emit('message:send', { channelId, content, messageType, replyToMessageId });
  }

  editMessage(messageId, content) {
    this.emit('message:edit', { messageId, content });
  }

  deleteMessage(messageId) {
    this.emit('message:delete', { messageId });
  }

  markAsRead(channelId, lastReadMessageId) {
    this.emit('message:read', { channelId, lastReadMessageId });
  }

  startTyping(channelId) {
    this.emit('typing:start', { channelId });
  }

  stopTyping(channelId) {
    this.emit('typing:stop', { channelId });
  }
}

export default new SocketService();
